import { gql } from "@apollo/client";

export const GET_CONVERSATIONS = gql`
  query GetConversations {
    conversations {
      id
      vendor
      isGroup
      groupName
      groupImage
      groupDescription
      unreadCount
      participants {
        id
        name
        lastname
        profileImage
        lastActivityDate
      }
      admins {
        id
        name
        lastname
      }
      createdBy {
        id
        name
        lastname
      }
      lastMessage {
        id
        text
        audioUrl
        fileUrls
        isSystemMessage
        createdAt
        sender {
          id
          name
        }
      }
      updatedAt
    }
  }
`;

export const GET_CONVERSATION_MESSAGES = gql`
  query GetConversationMessages(
    $conversationId: String!
    $limit: Float
    $skip: Float
  ) {
    conversationMessages(
      conversationId: $conversationId
      limit: $limit
      skip: $skip
    ) {
      id
      text
      audioUrl
      fileUrls
      isSystemMessage
      createdAt
      sender {
        id
        name
        lastname
        profileImage
      }
    }
  }
`;

export const USERS_ONLINE_STATUS = gql`
  query usersOnlineStatus($userIds: [String!]!) {
    usersOnlineStatus(userIds: $userIds) {
      userId
      online
      lastSeenAt
    }
  }
`;
